<template>
  <div class="shop-subcategory-area">
    <ButtonComponent
      v-if="!edit"
      :icon="area ? ['fal', 'ruler-triangle'] : ['fas', 'exclamation-circle']"
      :label="label"
      :theme="area ? 'default' : 'error'"
      @click="
        () => {
          edit = true
          $emit('track', 'Area')
        }
      "
    />
    <template v-else>
      <InputComponent v-model.number="area" align="right" suffix="m²" />
      <ButtonComponent :icon="['fal', 'check']" theme="primary" @click="submit" />
    </template>
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: Number,
  },
  watch: {
    value: {
      handler() {
        this.area = this.value
      },
      immediate: true,
    },
  },
  data() {
    return {
      edit: false,
      area: null,
    }
  },
  computed: {
    label() {
      if ([null, undefined].includes(this.value)) return this.$t('setArea')
      return `${this.value.toLocaleString()} m²`
    },
  },
  methods: {
    submit() {
      this.edit = false
      this.$emit('input', parseFloat(this.area) || null)
    },
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.shop-subcategory-area {
  display: flex;

  & > * {
    & + * {
      margin-left: 0.5rem;
    }
  }
}
</style>
